export enum MessagePurposeType {
    Notification = "Notification",
    Error = "Error"
}